module.exports = __webpack_public_path__ + "UX1.png?f50f83e792154978ea8889451546488c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX1.png
// module id = 58
// module chunks = 0